<template>
  <div class="attachment-wrapper p-1 border border-platinum rounded mb-2">
    <url-payload v-if="messageAttachmentType == 'urlBotPayloadTemplate'" :open-file-viewer='clicked' />
    <customer-payload v-if='messageAttachmentType == "customerBotPayloadTemplate"' />
    <error-payload v-if='messageAttachmentType == "botErrorTemplate"' />
    <image-payload v-if='messageAttachmentType == "imageTemplate"' />
    <inventory-payload v-if="messageAttachmentType == 'inventoryBotPayloadTemplate'" />
    <generic-file-payload v-if="messageAttachmentType == 'genericPrivateFileTemplate'"  :open-generic-file-attachment='clicked'/>
  </div>
</template>

<script>
  import UrlPayload from './UrlPayload'
  import CustomerPayload from './CustomerPayload'
  import ErrorPayload from './ErrorPayload.vue'
  import ImagePayload from './ImagePayload.vue'
  import InventoryPayload from './InventoryPayload.vue'
  import GenericFilePayload from './GenericFilePayload.vue'

  import {
    PayloadType,
    SupportedFilePreviewFormats
  } from '@/lib/utilities/enums'
  export default {
    name: 'messageAttachment',
    components: {
      UrlPayload,
      CustomerPayload,
      ErrorPayload,
      ImagePayload,
      InventoryPayload,
      GenericFilePayload
    },
    props: [
      'message'
    ],
    computed: {
      messageAttachmentType: function () {
        let vm = this;
        try {
          if (vm.message && vm.message.AttachmentFile) {
            //Check if it has a valid payload type
            if (vm.message.AttachmentFile.Payload && vm.message.AttachmentFile.PayloadType) {
              if (vm.message.AttachmentFile.PayloadType === PayloadType.Url)
                return "urlBotPayloadTemplate";
              else if (vm.message.AttachmentFile.PayloadType === PayloadType.Inventory)
                return "inventoryBotPayloadTemplate";
              else if (vm.message.AttachmentFile.PayloadType === PayloadType.Customer)
                return "customerBotPayloadTemplate";
              else if (vm.message.AttachmentFile.PayloadType === PayloadType.Error)
                return "botErrorTemplate";
              else if (vm.message.AttachmentFile.PayloadType === PayloadType.Form)
                return "formTemplate";
              else if (vm.message.AttachmentFile.PayloadType === PayloadType.Json)
                return "JSONtemplate"
            }

            if (vm.message.AttachmentFile.Url) {
              var fileName = vm.message.AttachmentFile.Url.toLowerCase();
              vm.fileExtension = vm.message.AttachmentFile.Extension;
              if (!vm.fileExtension && fileName.indexOf('.') >= 0)
                vm.fileExtension = vm.message.AttachmentFile.Url.substring(vm.message.AttachmentFile
                  .Url.lastIndexOf('.') + 1).toLowerCase();

              // || fileName.endsWith('tiff') || fileName.endsWith('tif'))    - TIFF/TIF previews aren't currently supported by all browsers
              // if (fileName.endsWith('jpg') || fileName.endsWith('jpeg') || fileName.endsWith('gif') ||
              //   fileName.endsWith('png') || fileName.endsWith('bmp') || vm.message.AttachmentFile.PayloadType == PayloadType.Giphy)
              if (SupportedFilePreviewFormats.indexOf(vm.fileExtension) >= 0 && SupportedFilePreviewFormats
                .indexOf(vm.fileExtension) <= SupportedFilePreviewFormats.length - 2)
                return 'imageTemplate';
              else //if (fileExtension && self.supportedFileFormats().indexOf(fileExtension) >= 0)
                return 'genericPrivateFileTemplate';
            }
          }
        } catch (err) {
          console.log(err);
        }
        return "invalid";
      }
    },
    data() {
      return {

      }
    },
    methods: {
      clicked: function () {
          console.log('clicked')
        }
    }
  }

</script>

<style lang="scss" scoped>
  .attachment-wrapper {
    width:fit-content;
  }
</style>



// WEBPACK FOOTER //
// src/components/Messenger/MessageList/Message/MessageAttachment/MessageAttachment.vue